import * as React from 'react';
import { AccordionItem, RichTextArea } from '@grandvisionhq/common';

const FaqItem = ({ id , question , answer , activeId , appendIdToUrl =true  })=>{
    const handleClick = React.useCallback((expanded)=>{
        if (expanded && id && appendIdToUrl) {
            history.replaceState(null, '', `#${id}`);
        }
    }, [
        id,
        appendIdToUrl
    ]);
    return /*#__PURE__*/ React.createElement(AccordionItem, {
        key: id,
        id: id,
        headingLevel: "h3",
        label: question,
        expanded: id === activeId,
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: answer
    }));
};

export { FaqItem as default };
//# sourceMappingURL=FaqItem.js.map
